import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Shaver = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 17"
      {...rest}
      fill={fill}
    >
      <g fillRule="evenodd" clipRule="evenodd">
        <path d="M4.333 1.3v1h7.333v-1h.666v1.667H3.666V1.301h.667Z" />
        <path d="M6.333 1.3v1.667h-.667V1.301h.667ZM8.333 1.3v1.667h-.667V1.301h.667ZM10.333 1.3v1.667h-.667V1.301h.667ZM8 11.967a.333.333 0 1 0 0 .667.333.333 0 0 0 0-.667Zm-1 .334a1 1 0 1 1 2 0 1 1 0 0 1-2 0ZM12 6.967H4v-.666h8v.666ZM8.333 8.967V10.3h-.667V8.967h.667Z" />
        <path d="M3.666 3.967h8.666v2.69l-1.061 7.277-.002.009a3.334 3.334 0 0 1-6.54 0l-.001-.008-1.062-7.277V3.967Zm.667.666V6.61l1.052 7.212a2.666 2.666 0 0 0 5.229 0l1.052-7.212V4.633H4.333Z" />
      </g>
    </svg>
  );
};

Shaver.category = 'product-category';

Shaver.displayName = 'Shaver';
